import React, { useState } from 'react';
import { InputBase } from '../Helper/InputBase';
import Button from 'react-bootstrap/Button';
import { restartIcon, printIcon } from '../../assets/images';
import { formatter, validate } from '../../utility';
import GeneralUtils from '../../utility/GeneralUtils';
import ROUTES from '../../constants/RouteConstants';
import { useEffect } from 'react';

const ValidationComplete = (props) => {
  const { validationData, setValidationData } = props;
  const { phase1RentAmount, calc_p1RemainingEligibleAmount, calc_p1MaxAdditionalRentIncrease, calc_p1IsPhase2Available, calc_p1IsRentIncreaseAmountValid, phase1RentAmountUsed } = props?.validationData;
  const [data, setRentData] = useState({
    phase1RentAmountUsed : '',
    errors: {}
  });

  useEffect(() => {
    if (!data?.phase1RentAmountUsed) {
      setRentData({  phase1RentAmountUsed, errors: {} })
    }
  },[phase1RentAmountUsed])

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    setRentData({...data, [name]: value, errors: { ...data?.errors, [name]: '' }});
  }

  const noEligibleAmount = () => {
    if (calc_p1RemainingEligibleAmount > 0) return;
    return <div>{props?.isTenantRoute ? 'The landlord has' : 'You have'} no eligible amount remaining for future additional rent increases and can now only apply a <a href="https://www2.gov.bc.ca/gov/content/housing-tenancy/residential-tenancies/rent-rtb/rent-increases" target="_blank" rel="noopener noreferrer">standard rent increase</a> to this unit.</div>
  }

  const continueClick = () => {
    const { phase1RentAmountUsed } = data;

    const rentAmountValidation = [
      {
        phase1RentAmountUsed: phase1RentAmountUsed ? phase1RentAmountUsed : '',
        validationRules: [{ isRequired: !calc_p1IsRentIncreaseAmountValid && calc_p1IsPhase2Available, errorMsg: 'Selected rent amount for phase 2 is required' }],
      },
    ];

    const rentAmountErrors = validate(rentAmountValidation);
    if (Object.keys(rentAmountErrors).length) {
      setRentData({ phase1RentAmountUsed, errors: rentAmountErrors });
      return;
    } else {
      setRentData({ phase1RentAmountUsed, errors: {} });
      const phase1RentAmountUsedTemp = !calc_p1IsRentIncreaseAmountValid && calc_p1IsPhase2Available ? data?.phase1RentAmountUsed : phase1RentAmount

      setValidationData({ ...validationData, ...{ phase1RentAmountUsed: phase1RentAmountUsedTemp, rentAmountError: !calc_p1IsRentIncreaseAmountValid && calc_p1IsPhase2Available ? Number(phase1RentAmountUsed) !== Number(calc_p1MaxAdditionalRentIncrease) : false } });
      GeneralUtils.log(`
        phase1RentAmountUsed: ${phase1RentAmountUsed}
      `);
      props?.navigate(ROUTES.RENT_INCREASE_CALCULATOR)
    }
  }

  const resetForm = () => {
    window.location.reload(false);
  }

  const print = () => {
    window.print();
  }
  
  return (
    <div className="validator__complete">
      { noEligibleAmount() }
      { !props?.isTenantRoute ? <div>
        { !calc_p1IsRentIncreaseAmountValid && calc_p1IsPhase2Available ? <p>
          Do you want to adjust your current rent to the the corrected amount above of {formatter.toAmountDisplay(calc_p1MaxAdditionalRentIncrease)}, or continue with the rent amount that you are charging the tenant today of {formatter.toAmountDisplay(phase1RentAmount)}. 
          <span className="w1-step-one__description-warning">&nbsp;Important: If you continue with an amount that is not determined to be correct, a warning will be included in your generated rent increase notice to inform the tenant of the discrepancy.</span>
        </p> : null }
        <div className="validator__rent-amount-used">
          { !calc_p1IsRentIncreaseAmountValid && calc_p1IsPhase2Available ? <InputBase
            name='phase1RentAmountUsed'
            cssClass='fri-questions__rent-amount-used'
            errors={data?.errors?.phase1RentAmountUsed}
            type='select'
            value={data.phase1RentAmountUsed}
            label=''
            handleSelectChange={handleSelectChange}
            selectList={[ { text: `Use calculated amount ${formatter.toAmountDisplay(calc_p1MaxAdditionalRentIncrease)}`, value: calc_p1MaxAdditionalRentIncrease }, { text: `Use entered amount ${formatter.toAmountDisplay(phase1RentAmount)}`, value: phase1RentAmount } ]}
          /> : null }
          { calc_p1IsPhase2Available ? <Button variant="success" className="step2-buttons-calculate hide-print" onClick={() => continueClick()}>Continue</Button> : null }
        </div>
        <div className="validator__print-container hide-print">
          <span className="w1-step-four__buttons__print" onClick={() => print()}>
            <img className="w1-step-four__buttons__print__icon" src={printIcon} alt='' /> Print
          </span>
          <span className="w1-step-four__buttons__restart" onClick={() => resetForm()}>
            <img className="w1-step-four__buttons__print__icon" src={restartIcon} alt='' /> Start Over
          </span>
        </div>
      </div> : null }
    </div>
  )
}

export default ValidationComplete;